//
//
//
//
//
//
//
//
//
//
//

import jQuery from 'jquery';
import chosen from 'chosen-js';

export default {
  props: {
    value: String,
    settings: Object,
  },
  data() {
    return {
      internalValue: this.$options.value || this.value || '',
      internalSettings: this.$options.settings || this.settings || {},
    };
  },
  updated() {
    this.chosen.trigger("chosen:updated");
  },
  mounted() {
    let _this = this;
    this.chosen = jQuery(this.$el).chosen(this.settings).on('change', function(e) {
      _this.internalValue = this.value;
      _this.onChange();
    });
  },
  methods: {
    onChange() {
      this.$emit('input', this.internalValue)
    }
  },
}



// WEBPACK FOOTER //
// ./app/components/atoms/eq-select/eq-select.vue